import { BookingService } from '../../services/booking.service';
import { CalendarEvent } from '../../models/calendar.model';
import { Component, Input } from '@angular/core';
import moment from 'moment';
import { NeighborhoodService } from '../../services/neighborhood.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-booking-detail-modal',
  templateUrl: './booking-detail-modal.component.html',
  styleUrl: './booking-detail-modal.component.scss'
})
export class BookingDetailModalComponent {

  @Input() event?: CalendarEvent;

  constructor(
    public activeModal: NgbActiveModal,
    public bookingService: BookingService,
    public neighborhoodService: NeighborhoodService
  ) {

  }

  get timeZone(): number {
    return this.neighborhoodService.currentNeighborhood?.timeZone ?? 0;
  }

  get cancelEnabled(): boolean {
    return this.event
      ? this.event.booking.cancelEnabled(this.timeZone)
      : false;
  }

  get deleteEnabled(): boolean {
    return this.event
      ? !this.event.hasEnded
      : false;
  }

  get hasActions(): boolean {
    return this.cancelEnabled || this.deleteEnabled;
  }

  get googleCalendarEnabled(): boolean {
    return this.event
      ? this.event.state === 'active'
      : false;
  }

  get googleCalendarUrl(): string {

    if (!this.event) {
      return '';
    }

    const startAt = moment.utc(this.event.booking.startDate).format('YYYYMMDDTHHmmss[Z]');
    const endAt = moment.utc(this.event.booking.endDate).format('YYYYMMDDTHHmmss[Z]');

    const neighborhoodName = this.neighborhoodService.currentNeighborhood?.name ?? '';

    const title = neighborhoodName.length > 0
      ? `${neighborhoodName} - Reservación | ${this.event.amenityName} | CradleResident`
      : `Reservación | ${this.event.amenityName} | CradleResident`;

    const details = [
      `Calle: ${this.event.streetName}`,
      `Número: ${this.event.houseNumber}`,
      `Invitados: ${this.event.guests}`
    ].join('\n');

    const location = this.neighborhoodService.currentNeighborhood?.name ?? this.event.amenityName;

    const parameters = [
      'action=TEMPLATE',
      `text=${encodeURIComponent(title)}`,
      `dates=${startAt}/${endAt}`,
      `details=${encodeURIComponent(details)}`,
      `location=${encodeURIComponent(location)}`
    ].join('&');

    return `https://calendar.google.com/calendar/render?${parameters}`;
  }

  /*
   ██████╗ █████╗ ███╗   ██╗ ██████╗███████╗██╗
  ██╔════╝██╔══██╗████╗  ██║██╔════╝██╔════╝██║
  ██║     ███████║██╔██╗ ██║██║     █████╗  ██║
  ██║     ██╔══██║██║╚██╗██║██║     ██╔══╝  ██║
  ╚██████╗██║  ██║██║ ╚████║╚██████╗███████╗███████╗
   ╚═════╝╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝╚══════╝╚══════╝

  */
  async cancel(): Promise<void> {

    if (!this.event) {
      return;
    }

    const flag = confirm(
      '¿Estás seguro de que quieres cancelar esta reservación?'
    );

    if (flag) {

      const done = await this.bookingService.update(
        this.event.booking
      );

      if (done) {
        this.activeModal.close('cancelled');
      }
    }
  }

  /*
  ██████╗ ███████╗██╗     ███████╗████████╗███████╗
  ██╔══██╗██╔════╝██║     ██╔════╝╚══██╔══╝██╔════╝
  ██║  ██║█████╗  ██║     █████╗     ██║   █████╗
  ██║  ██║██╔══╝  ██║     ██╔══╝     ██║   ██╔══╝
  ██████╔╝███████╗███████╗███████╗   ██║   ███████╗
  ╚═════╝ ╚══════╝╚══════╝╚══════╝   ╚═╝   ╚══════╝

  */
  async delete(): Promise<void> {

    if (!this.event) {
      return;
    }

    const flag = confirm(
      '¿Estás seguro de que quieres eliminar esta reservación?'
    );

    if (flag) {

      const done = await this.bookingService.delete(
        this.event.booking
      );

      if (done) {
        this.activeModal.close('deleted');
      }
    }
  }

}
